// PDF Output Service template the BFF renders from the submitted request and attaches to the
// confirmation mail as the Aanvraag PDF (send-deferred pdfTemplateCode). Shared by both SAA apps.
export const SAA_APPLICATION_PDF_TEMPLATE = 'AanvraagIIP';

// Attachment name for that PDF (send-deferred pdfFileName). Shared for the same
// reason as the template code: both SAA apps send the same mail, so a rename has
// to land in both at once, and each app's tests only assert its own literal -
// nothing would catch the two drifting apart.
export function saaApplicationPdfFileName(lang: 'nl' | 'en'): string {
  return lang === 'nl' ? 'Aanvraag.pdf' : 'Application.pdf';
}
